import React, { useEffect, useState } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
import Review from '../../Pages/CompanyDetail/Subpages/Reviews/Review';
import { makeStyles } from "@material-ui/core/styles";

import ApproveRejectModal from '../Admin/Components/ApproveRejectModal';

import { getAllUnreadReviews, getAllVerifiedReviews, getAllRejectedReviews } from '../../db';

const useStyles = makeStyles((theme) => ({
    container: {
      height: "calc(100vh - 180px)",
      maxHeight: "calc(100vh - 100px)",
      width: "calc(100% - 300px)",
      display: "flex",
      justifyContent: "center",
      overflow: "auto",
      margin: "auto"
    },
}));


export default function Reviews() {
    const [unreadReviews, setUnreadReviews] = React.useState([])
    const [verifiedReviews, setVerifiedReviews] = React.useState([])
    const [rejectedReviews, setRejectedReviews] = React.useState([])
    const [loading, setLoading] = React.useState(true);
    const [tab, setTab] = React.useState("unread");

    const classes = useStyles();

    useEffect(() => {
        async function fetchData() {
            console.log('fetch data called')

            switch(tab) {
                case "approved":
                    const verifiedReviews = await getAllVerifiedReviews();
                    setVerifiedReviews(verifiedReviews);
                    break;
                case "rejected":
                    const rejectedReviews = await getAllRejectedReviews();
                    setRejectedReviews(rejectedReviews);
                    break;
                case "unread":
                default:
                    const unreadReviews = await getAllUnreadReviews();
                    setUnreadReviews(unreadReviews);
                    break;
            }
        
            setLoading(false);
        }
        setLoading(true);
        fetchData(tab);
    }, [tab])

    const renderReviews = () => {
        if (loading) {
            return (
                <CircularProgress />
            )
        }

        switch (tab) {

            case "approved":
                return <ReviewsList reviews={verifiedReviews} onAction={() => setTab("")} />
            case "rejected":
                return <ReviewsList reviews={rejectedReviews} onAction={() => setTab("")} />
            case "unread":
            default:
                return <ReviewsList reviews={unreadReviews} onAction={() => setTab("")} />
        }

        return null;
    }

    return (
        <div>
            <ReviewsRadio tab={tab} setTab={(event) => setTab(event.target.value)} />
            <div className={classes.container}>
                {renderReviews()}
            </div>
        </div>
    )
}


function ReviewsList({ reviews, onAction }) {
    const classes = useStyles();

    if (!reviews.length) {
        return (
            <div className={classes.container}>No Results</div>
        )
    }

    return (
        <div>
            {reviews.map((review) => <Review review={review} onAdminAction={onAction} admin />)}
        </div>
    )
}

function ReviewsRadio({ tab, setTab }) {
    return (
        <div>
            `<FormControl component="fieldset">
                <RadioGroup value={tab || "unread"} row aria-label="position" name="position" defaultValue="unread" onChange={setTab}>
                    <FormControlLabel
                        value="unread"
                        control={<Radio color="primary" />}
                        label="Unread"
                        labelPlacement="top"
                    />
                    <FormControlLabel
                        value="approved"
                        control={<Radio color="primary" />}
                        label="Approved"
                        labelPlacement="top"
                    />
                    <FormControlLabel
                        value="rejected"
                        control={<Radio color="primary" />}
                        label="Rejected"
                        labelPlacement="top"
                    />
                </RadioGroup>
            </FormControl>    
        </div>
    )
}